// Pathways.js
import React, { useState } from 'react';
import PathwayFormModal from './PathwayFormModal';
import PathwayList from './PathwayList';
import ClassSearch from '../../ClassSearch/ClassSearch';
import CustomSidebar from '../Sidebar/Sidebar';

// Import the new dashboard
import CurriculumAnalyticsDashboard from './curriculumAnalyticsDashboard';

// Import the new Programs component
import Programs from './Programs';

// Import the new ProgramAnalysisOverview page
import ProgramAnalysisOverview from './ProgramAnalysisOverview';

const Pathways = () => {
  // Default tab is now "dashboard"
  const [activeTab, setActiveTab] = useState('dashboard');

  // NEW: Keep track of which program is selected
  const [selectedProgram, setSelectedProgram] = useState(null);

  const handleSavePathway = () => {
    setActiveTab('list');
  };

  // Callback to handle user clicking on a program in the Programs table
  const handleSelectProgram = (program) => {
    setSelectedProgram(program);
    // Switch to our new "programanalysisoverview" view
    setActiveTab('programanalysisoverview');
  };

  return (
    <div className="flex">
      <CustomSidebar adjustment="Pathways" />
      <div className="flex-1 ml-0">
        {/* Top Tab Bar */}
        <div
          className="fixed ml-14 top-6 left-1/2 transform -translate-x-1/2
                     bg-white dark:bg-gray-800 z-10 w-full"
        >
          <div className="flex justify-center">
            <ul
              className="flex space-x-4 py-2 text-sm font-medium text-center
                         text-gray-500 dark:text-gray-400"
              id="default-tab"
              data-tabs-toggle="#default-tab-content"
              role="tablist"
              style={{ listStyleType: 'none' }}
            >
              {/* Dashboard Tab */}
              <li role="presentation">
                <button
                  className={`inline-block py-3 px-6 whitespace-nowrap ${
                    activeTab === 'dashboard'
                      ? 'text-blue-600 border-b-2 border-blue-600'
                      : 'hover:text-gray-600 dark:hover:text-gray-300'
                  }`}
                  id="dashboard-tab"
                  type="button"
                  role="tab"
                  aria-controls="dashboard"
                  aria-selected={activeTab === 'dashboard'}
                  onClick={() => setActiveTab('dashboard')}
                >
                  Dashboard
                </button>
              </li>

              {/* NEW Programs Tab */}
              <li role="presentation">
                <button
                  className={`inline-block py-3 px-6 whitespace-nowrap ${
                    activeTab === 'programs'
                      ? 'text-blue-600 border-b-2 border-blue-600'
                      : 'hover:text-gray-600 dark:hover:text-gray-300'
                  }`}
                  id="programs-tab"
                  type="button"
                  role="tab"
                  aria-controls="programs"
                  aria-selected={activeTab === 'programs'}
                  onClick={() => setActiveTab('programs')}
                >
                  Programs
                </button>
              </li>

              {/* Pathway List Tab */}
              <li role="presentation">
                <button
                  className={`inline-block py-3 px-6 whitespace-nowrap ${
                    activeTab === 'list'
                      ? 'text-blue-600 border-b-2 border-blue-600'
                      : 'hover:text-gray-600 dark:hover:text-gray-300'
                  }`}
                  id="list-tab"
                  type="button"
                  role="tab"
                  aria-controls="list"
                  aria-selected={activeTab === 'list'}
                  onClick={() => setActiveTab('list')}
                >
                  Pathway List
                </button>
              </li>

              {/* Create New Pathway Tab */}
              <li role="presentation">
                <button
                  className={`inline-block py-3 px-6 whitespace-nowrap ${
                    activeTab === 'form'
                      ? 'text-blue-600 border-b-2 border-blue-600'
                      : 'hover:text-gray-600 dark:hover:text-gray-300'
                  }`}
                  id="form-tab"
                  type="button"
                  role="tab"
                  aria-controls="form"
                  aria-selected={activeTab === 'form'}
                  onClick={() => setActiveTab('form')}
                >
                  Create New Pathway
                </button>
              </li>

              {/* Class Search Tab */}
              <li role="presentation">
                <button
                  className={`inline-block py-3 px-6 whitespace-nowrap ${
                    activeTab === 'search'
                      ? 'text-blue-600 border-b-2 border-blue-600'
                      : 'hover:text-gray-600 dark:hover:text-gray-300'
                  }`}
                  id="search-tab"
                  type="button"
                  role="tab"
                  aria-controls="search"
                  aria-selected={activeTab === 'search'}
                  onClick={() => setActiveTab('search')}
                >
                  Class Search
                </button>
              </li>
            </ul>
          </div>
          <div className="border-b border-gray-200 dark:border-gray-700"></div>
        </div>

        {/* Tab Content */}
        <div id="default-tab-content" className="mt-24 ml-20">
          {activeTab === 'dashboard' && <CurriculumAnalyticsDashboard />}
          {activeTab === 'programs' && <Programs onSelectProgram={handleSelectProgram} />}
          {activeTab === 'list' && <PathwayList />}
          {activeTab === 'form' && (
            <PathwayFormModal
              onSave={handleSavePathway}
              handleClose={() => setActiveTab('list')}
            />
          )}
          {activeTab === 'search' && <ClassSearch adjustment="admin" />}

          {/* NEW: Program Analysis Overview "page" */}
          {activeTab === 'programanalysisoverview' && (
            <ProgramAnalysisOverview
              program={selectedProgram}
              onBack={() => setActiveTab('programs')}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Pathways;
